import {isNullOrUndefined} from 'ceres/app/helper/utils';

export function getCookie(name) {

    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);

    if(parts.length === 2) {

        const value = parts.pop().split(';').shift();

        if(value.indexOf('{') === -1) {
            return value;
        }else {
            return JSON.parse(value);
        }
    }
}

export function setCookie(name, value) {
    document.cookie = name + '=' + value  + '; path=/';
}

export function setPriceTypeMapCookie(lang, type) {

    let cookie = getCookie('price_type_map');

    if(isNullOrUndefined(cookie)) {
        cookie            = {};
        cookie[lang] = type
    }else {
        cookie[lang] = type
    }

    setCookie('price_type_map', JSON.stringify(cookie))
}
